import { render } from "./stored-value-card.vue?vue&type=template&id=efaab2a0&scoped=true"
import script from "./stored-value-card.vue?vue&type=script&lang=js"
export * from "./stored-value-card.vue?vue&type=script&lang=js"

import "./stored-value-card.vue?vue&type=style&index=0&id=efaab2a0&scoped=true&lang=less"

import exportComponent from "/home/www/jenkins/jenkins_home/workspace/yizhige_production/yizhige_admin_pro/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-efaab2a0"]])

export default __exports__